var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var ToggleOff = function ToggleOff(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 9 2' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M8 2H1c-.6 0-1-.4-1-1 0-.5.4-1 1-1h7c.5 0 1 .4 1 1s-.4 1-1 1z', className: 'st0' })
    )
  );
};
/*eslint-enable */

export default ToggleOff;
//# sourceMappingURL=ToggleOff.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/ToggleOff.js